"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _material = require("@mui/material");

var _MotivatorIcons = require("../../MotivatorIcons");

var _common = require("../../../common");

var _constants = require("../../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MotivatorOptionLabel = function MotivatorOptionLabel(_ref) {
  var scale_id = _ref.scale_id,
      idx = _ref.idx;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var scaleName = (0, _common.getScaleNameById)(scale_id);

  var Icon = _MotivatorIcons.ALL_MOTIVATOR_ICONS["".concat(scaleName, "Filled")];

  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    alignItems: "center",
    key: idx
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    height: "25px"
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      marginLeft: '10px',
      fontWeight: '600'
    }
  }, (0, _common.capitalize)(t("".concat(_constants.SCALES_BY_ID[scale_id].replace(' ', '_'))))));
};

var _default = MotivatorOptionLabel;
exports.default = _default;